module.exports = __webpack_public_path__ + "static/night-train-to-lisbon-f7be3168293662d668b2f0788c8ea8d9.jpg";